import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { Button, Form, InputGroup, FormControl } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Swal from "sweetalert2";
import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from "@tanstack/react-table";


function Stafflist() {

    const accesstoken = localStorage.getItem("token");
    const [syncing, setSyncing] = useState(false);
    const [data, setData] = useState([]);
    const [button, setbutton] = useState("Users");
    const [User, setUser] = useState(false);
    const [role, setrole] = useState(false);
    const [group, setgroup] = useState(false);
    const [value, setvalue] = useState("");
    const [show, setshow] = useState(false);
    const navigate = useNavigate();

    // TanStack Table state
    const [sorting, setSorting] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");

    const handleSync = async () => {
        const confirm = await Swal.fire({
            title: "Sync Staff?",
            text: "This will fetch staff from the live database and sync them here.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Sync",
            cancelButtonText: "Cancel",
        });

        if (!confirm.isConfirmed) return;

        setSyncing(true);
        try {
            const res = await axios.post(
                baseurladdress + "staff/syncstaff",
                { startindex: 0, endindex: 10 },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );

            const { synced = 0, failed = 0, errors = [] } = res.data;

            let errorHtml = "";
            if (errors.length > 0) {
                errorHtml = `<details style="margin-top:8px;font-size:12px;text-align:left">
        <summary>${failed} failed (click to expand)</summary>
        <ul>${errors.map((e) => `<li>Index ${e.index}: ${e.reason}</li>`).join("")}</ul>
      </details>`;
            }

            Swal.fire({
                title: "Sync Complete",
                html: `
        <div style="text-align:left; font-size:14px;">
          <p>✅ Synced: <strong>${synced}</strong></p>
          <p>❌ Failed: <strong>${failed}</strong></p>
          ${errorHtml}
        </div>`,
                icon: synced > 0 ? "success" : "warning",
            });

            // Reload staff list
            const reload = await axios.get(baseurladdress + "staff/findallstaff", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            });
            if (reload.data.status === "Success") setData(reload.data.staff);

        } catch (err) {
            console.error("Sync error:", err);
            Swal.fire("Error", "Sync failed. Please try again.", "error");
        } finally {
            setSyncing(false);
        }
    };
    useEffect(() => {
        const GetAllUsers = () => {
            axios
                .get(baseurladdress + "staff/findallstaff", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        setData(res.data.staff);
                    } else {
                        setData([]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    alert("Failed to load staff list");
                });
        };


        GetAllUsers();
    }, []);

    function deleteStaff(staff_id) {
        Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(baseurladdress + `staff/deletestaff/${staff_id}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8",
                        Authorization: `Bearer ${accesstoken}`,
                    },
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.status === "success") {
                            // Success toast
                            Swal.fire({
                                toast: true,
                                position: "top-end",
                                icon: "success",
                                title: "Deleted Successfully",
                                showConfirmButton: false,
                                timer: 1200,
                                timerProgressBar: true,
                            });

                            // Refresh data
                            axios
                                .get(baseurladdress + "staff/findallstaff", {
                                    headers: { Authorization: `Bearer ${accesstoken}` },
                                })
                                .then((res) => {
                                    if (res.data.status === "Success") {
                                        setData(res.data.staff);
                                    }
                                });
                        } else if (result.status === "Not Found") {
                            Swal.fire({
                                icon: "error",
                                title: "Not Found",
                                text: "Staff not found or already deleted.",
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Failed",
                                text: "Unable to delete staff. Please try again.",
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Delete staff error:", error);
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Something went wrong while deleting staff.",
                        });
                    });
            }
        });
    }

    function AddStaff() {
        //window.location.href = "/AddStaff";
        navigate("/addstaff");
    }

    function EditStaff(staff_id) {
        //window.location.href = "/AddStaff";
        navigate("/editstaff/" + staff_id);
    }

    // Define columns for TanStack Table
    const columns = useMemo(
        () => [
            {
                accessorKey: "index",
                header: "Sl.No",
                size: 60,
                cell: ({ row }) => row.index + 1,
            },
            {
                accessorKey: "staff_code",
                header: "Staff Code",
                size: 120,
            },
            {
                accessorKey: "staff_name",
                header: "Staff Name",
                size: 150,
            },
            {
                accessorKey: "district_name",
                header: "Place",
                size: 120,
            },
            {
                accessorKey: "staff_mobile",
                header: "Contact",
                size: 120,
            },
            {
                accessorKey: "staff_status",
                header: "Status",
                size: 100,
                cell: ({ row }) => (
                    <div>
                        {row.original.staff_status == 1 ? (
                            <span className="badge bg-success">Active</span>
                        ) : (
                            <span className="badge bg-danger">Inactive</span>
                        )}
                    </div>
                ),
            },
            {
                accessorKey: "actions",
                header: "Actions",
                size: 80,
                enableSorting: false,
                cell: ({ row }) => (
                    <div className="d-flex gap-2">
                        <Icon.PencilSquare
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => EditStaff(row.original.staff_id)}
                        />
                        <Icon.Trash
                            className="text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteStaff(row.original.staff_id)}
                        />
                    </div>
                ),
            },
        ],
        []
    );

    // Create table instance
    const table = useReactTable({
        data: data,
        columns,
        state: {
            sorting,
            globalFilter,
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: {
            pagination: {
                pageSize: 10,
            },
        },
    });

    return (

        <div className="content-wrap">

            <div className="main">
                <div className="container-fluid">


                    <section id="main-content">

                        <div class="card">
                            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
                                <h6 className="card-title">STAFF DETAILS</h6>
                                <div className="d-flex align-items-center">
                                    <Button
                                        variant="light"
                                        size="sm"
                                        onClick={(e) => {
                                            AddStaff();
                                            e.currentTarget.blur();
                                        }}
                                        className="d-flex align-items-center"
                                    >
                                        <Icon.Plus className="me-1" />
                                        Add
                                    </Button>
                                    {/* <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={handleSync}
                                        disabled={syncing}
                                        className="d-flex align-items-center gap-1"
                                    >
                                        {syncing ? (
                                            <><span className="spinner-border spinner-border-sm" /> Syncing...</>
                                        ) : (
                                            <><Icon.ArrowRepeat size={15} /> Sync Staff</>
                                        )}
                                    </Button> */}
                                </div>

                            </div>

                            <div class="card-body">
                                {/* Page Size and Search Controls */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted small">Show</span>
                                        <Form.Select
                                            size="sm"
                                            style={{ width: "70px" }}
                                            value={table.getState().pagination.pageSize}
                                            onChange={(e) => {
                                                table.setPageSize(Number(e.target.value));
                                            }}
                                        >
                                            {[5, 10, 20, 50].map((pageSize) => (
                                                <option key={pageSize} value={pageSize}>
                                                    {pageSize}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <span className="text-muted small">entries</span>
                                    </div>

                                    <InputGroup style={{ width: "250px" }}>
                                        <InputGroup.Text>
                                            <Icon.Search size={14} />
                                        </InputGroup.Text>
                                        <FormControl
                                            size="sm"
                                            placeholder="Search..."
                                            value={globalFilter ?? ""}
                                            onChange={(e) => setGlobalFilter(e.target.value)}
                                        />
                                    </InputGroup>
                                </div>

                                {/* Table */}
                                <div className="table-responsive">
                                    <table className="table table-hover table-sm align-middle">
                                        <thead className="table-light">
                                            {table.getHeaderGroups().map((headerGroup) => (
                                                <tr key={headerGroup.id}>
                                                    {headerGroup.headers.map((header) => (
                                                        <th
                                                            key={header.id}
                                                            style={{ width: header.getSize() }}
                                                            className="text-nowrap"
                                                        >
                                                            {header.isPlaceholder ? null : (
                                                                <div
                                                                    {...{
                                                                        className: header.column.getCanSort()
                                                                            ? "cursor-pointer select-none d-flex align-items-center"
                                                                            : "",
                                                                        onClick: header.column.getToggleSortingHandler(),
                                                                    }}
                                                                >
                                                                    {flexRender(
                                                                        header.column.columnDef.header,
                                                                        header.getContext()
                                                                    )}
                                                                    {header.column.getCanSort() && (
                                                                        <span className="ms-1">
                                                                            {{
                                                                                asc: <Icon.ChevronUp size={12} />,
                                                                                desc: <Icon.ChevronDown size={12} />,
                                                                            }[header.column.getIsSorted()] ?? (
                                                                                    <Icon.ChevronExpand size={12} className="text-muted" />
                                                                                )}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </th>
                                                    ))}
                                                </tr>
                                            ))}
                                        </thead>
                                        <tbody>
                                            {table.getRowModel().rows.length > 0 ? (
                                                table.getRowModel().rows.map((row) => (
                                                    <tr key={row.id}>
                                                        {row.getVisibleCells().map((cell) => (
                                                            <td
                                                                key={cell.id}
                                                                style={{
                                                                    textAlign: "left",
                                                                    verticalAlign: "middle",
                                                                }}
                                                            >
                                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={columns.length} className="text-center text-muted py-4">
                                                        No staff found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Compact Pagination */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div className="text-muted small">
                                        Showing {table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1} to{" "}
                                        {Math.min(
                                            (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
                                            table.getFilteredRowModel().rows.length
                                        )}{" "}
                                        of {table.getFilteredRowModel().rows.length} entries
                                    </div>

                                    <div className="btn-group btn-group-sm">
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.setPageIndex(0)}
                                            disabled={!table.getCanPreviousPage()}
                                        >
                                            <Icon.ChevronDoubleLeft size={14} />
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.previousPage()}
                                            disabled={!table.getCanPreviousPage()}
                                        >
                                            <Icon.ChevronLeft size={14} />
                                        </Button>
                                        <Button variant="outline-secondary" disabled>
                                            Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.nextPage()}
                                            disabled={!table.getCanNextPage()}
                                        >
                                            <Icon.ChevronRight size={14} />
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                            disabled={!table.getCanNextPage()}
                                        >
                                            <Icon.ChevronDoubleRight size={14} />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        </div>

    )
}

export default Stafflist;